import TableOfCheckins from './TableOfCheckins.component';

export default TableOfCheckins;
